import { render } from "./GoodDetails.vue?vue&type=template&id=29b8178e&scoped=true"
import script from "./GoodDetails.vue?vue&type=script&lang=js"
export * from "./GoodDetails.vue?vue&type=script&lang=js"

import "./GoodDetails.vue?vue&type=style&index=0&id=29b8178e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29b8178e"]])

export default __exports__